// component/ScrollToTop.jsx
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const ScrollToTop = () => {
  const { pathname, search } = useLocation();

  useEffect(() => {
    // Reset scroll position for both document and main layout container
    document.documentElement.scrollTop = 0;
    document.body.scrollTop = 0;

    // Also scroll the main layout container if it exists
    const mainLayout = document.querySelector('.main-layout');
    if (mainLayout) {
      mainLayout.scrollTop = 0;
    }

    // Reset body overflow style to ensure scrolling works properly on new page
    document.body.style.overflow = '';
    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.width = '';
  }, [pathname, search]);

  return null;
};

export default ScrollToTop;
